<template>
  <div class="login-form-wrapper">
    <div class="content text-center">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submitForm)" class="loginForm">
          <div class="text-center">
            <div class="logo">
              <img alt class="login-logo" src="@/assets/images/login-logo.png" />
              <img alt class="login-logo-text" src="@/assets/images/login-logo-text.png" />
            </div>
            <div class="login-hint-label">{{ loginHintLabel }}</div>
          </div>
          <div class="text-left">
            <router-link class="btn-back" :to="{ name: 'login' }">戻る</router-link>
          </div>
          <div class="form-group position-relative">
            <label for="user_id">ID</label>
            <ValidationProvider rules="required" v-slot="{ errors }">
              <input type="text" v-model="user.username" class="form-control" id="user_id" />
              <div class="form-login-icon">
                <i class="icon-user"></i>
              </div>
              <small class="text-danger position-absolute">{{ errors[0] || errorMsg }}</small>
            </ValidationProvider>
          </div>
          <div class="form-group position-relative">
            <label for="password">Password</label>
            <ValidationProvider name="password" rules="password" v-slot="{ errors }">
              <input type="password" v-model="user.password" id="password" class="form-control valid" />
              <div class="form-login-icon">
                <i class="icon-key"></i>
              </div>
              <small class="text-danger position-absolute">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>
          <div class="text-center">
            <button type="submit" class="btn btn-login btn-outline-success">ログイン</button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
  props: {
    role: {
      type: String,
      required: true,
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      errorMsg: null,
      user: {
        username: '',
        password: '',
      },
    };
  },
  computed: {
    roleNotSelected() {
      return !this.role;
    },
    loginHintLabel() {
      let hint = null;
      switch (this.role) {
        case 'teacher':
          hint = '先生用';
          break;
        case 'corporation_brand_school':
          hint = '管理用';
          break;
      }

      return hint;
    },
  },
  methods: {
    submitForm() {
      let formData = {
        role: this.role,
        username: this.user.username,
        password: this.user.password,
      };

      this.$logger.debug('[Login#Form Component] Submitting:', formData);
      this.$store
        .dispatch('auth/login', formData)
        .then(() => {
          this.$router.push({ name: 'home' }).catch((error) => {
            if (error.name != 'NavigationDuplicated') {
              throw error;
            }
          });
        })
        .catch((error) => {
          this.$logger.error('[Login#Form Component]', error.response.data.error);
          switch (error.response.data.error) {
            case 'Login is invalid. Please try again.':
              this.errorMsg = 'ログインに失敗しました';
              break;
            case 'Account is frozen':
              this.errorMsg = 'このIDはご利用いただけません';
              break;
            default:
              this.errorMsg = error.response.data.error;
              break;
          }
        });
    },
    setRole(role) {
      this.$logger.debug('[Login#Form Component] role:', role);
      this.role = role;
    },
  },
};
</script>

<style lang="scss" scoped>
.login-form-wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: relative;
  .content {
    width: 100%;
    margin-top: -42px;
    .logo {
      text-align: center;
      display: block;
      margin-bottom: 10px;
      img {
        text-align: center;
        display: block;
        margin: auto;
        &.login-logo {
          margin-bottom: 15px;
          width: 50px;
        }
        &.login-logo-text {
          width: 118px;
        }
      }
    }
    .btn-back {
      margin-bottom: 40px;
      display: block;
    }
    .login-text {
      color: #42b195;
      font-size: 20px;
      margin-bottom: 40px;
    }
    .buttons {
      width: 100%;
      text-align: center;
      button,
      a {
        display: block;
        width: 65%;
        margin: 40px auto;
      }
    }
  }

  .footer {
    color: #7e7964;
    font-size: 8px;
    position: absolute;
    bottom: 0px;
    width: 100%;
  }

  form.loginForm {
    padding: 30px;
    text-align: left;
    .logo {
      text-align: center;
      display: block;
      margin-bottom: 14px;
      img {
        text-align: center;
        display: block;
        margin: auto;
        &.login-logo {
          margin-bottom: 15px;
          width: 50px;
        }
        &.login-logo-text {
          width: 118px;
        }
      }
    }
    .login-hint-label {
      height: 50px;
    }
    label {
      font-weight: bold;
    }
    input {
      border-radius: 12px;
    }
    .btn-login {
      margin-top: 10px;
      background-color: transparent;
      color: #28a745;
      padding: 4px 20px;
      border-radius: 4px;
    }
    .form-group {
      .form-login-icon {
        position: absolute;
        width: auto;
        bottom: 3px;
        right: 5px;
        margin-top: 0;
        font-size: 90%;
        color: #6c757dab;
      }
    }
  }
}
</style>
